import { utilityServicesPath} from "../../Constants";
import axios from "axios";
import FileService from "../orders/orders/organization/FileService";

const restUrl = utilityServicesPath + "/customers"

export default class UtilityCustomerService {
    static async getAllProjectFileNames(orderId) {
        return axios.get(`${restUrl}/file-names/orders/${orderId}/project`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async uploadOrderFile(year, orderId, fileNameType, files) {
        return await axios.post(`${restUrl}/files/upload/order-files?orderId=${orderId}&year=${year}`,
            FileService.getFormDataArray(files), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async delete(fileId) {
        return await axios.delete(`${restUrl}/files/delete?fileId=${fileId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async editFile(fileId, data) {
        return await axios.put(`${restUrl}/file-names/${fileId}`, JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            }
        });
    }
}